<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/Text/Covenant_with_Hell2#Contents-A">Epigraph</a></p>
<p class="fp">We have made a covenant with death, and with hell are we at agreement; when the overflowing scourge shall pass through, it shall not come unto us: for we have made lies our refuge, and under falsehood have we hid ourselves.</p>
<p class="fp para-style-override-3">Isaiah 28:15</p>
<p class="fp para-style-override-3">(King James Version)</p>
<p class="fp"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Covenant_with_Hell-5.vue?7c73251d